import keys from './keys'

const obj = {
  [keys.lessThan25k]: {
    key: keys.lessThan25k,
    getName: (lang = 'en') => {
      if (lang === 'ar') return '-أقل من ٢٥،٠٠٠ دولار'
      return 'Less than $25,000'
    },
    serverValue: '< $25000',
  },
  [keys.between25k50k]: {
    key: keys.between25k50k,
    getName: (lang = 'en') => {
      if (lang === 'ar') return '- من ٢٥.٠٠٠ الى ٥٠،٠٠٠ دولار'
      return '$25,000-$50,000'
    },
    serverValue: '$25000-$50000',
  },
  [keys.moreThan50k]: {
    key: keys.moreThan50k,
    getName: (lang = 'en') => {
      if (lang === 'ar') return '-أكثر من ٥٠،٠٠٠ دولار'
      return 'More than $50,000'
    },
    serverValue: '> $50000',
  },
}

export default obj
